import Vue from 'vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from 'vuex_path/store'
import App from './App.vue'
import vueForm from 'vue-form';

import spinnerCss from 'app/spinner.css';
import materialIconsCss from 'vendor/vue-material/fonts/material-icons.css';
import 'swiper/swiper-bundle.css';
import comfortlifeCss from 'assets/fonts/comfortlife/css/comfortlife.css';
import animateCss from 'app/animate.css';

import mainModalCss from 'app/main_modal.css';

import mainVuetifyCss from 'app/main_vuetify.css';
import mainCss from 'app/main.css';
import transitionsVuetifyCss from 'app/transitions_vuetify.css';
import controlDeviceCss from 'common/components/widget/control-device/control-device.css';

import Vuelidate from 'vuelidate'
import VueScrollTo from 'vue-scrollto'
import Ripple from 'vue-ripple-directive'
import VueLazyload from 'vue-lazyload'
import GetTextPlugin from 'vue-gettext'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import translations from 'locale/translations.json'

import { dragelt } from 'common/directives/dragelt.js';

import VueMqtt from 'common/services/mqtt/Main.js';
import VersionInfos from 'common/classes/VersionInfos';

import { v4 as uuidV4 } from 'uuid';


import User from 'common/classes/User.js';

import UserResource from 'common/services/resources/user.js'
import LanguageService from 'common/services/language.js'
import StorageService from 'common/services/storage.js'
import CordovaService from 'common/services/cordova.js'
import ToastService from 'common/services/toast.js'
import SystemService from 'common/services/system.js'
import LogService from 'common/services/log.js'

//window._ = require('lodash');
window._upperFirst = require('lodash/upperFirst');
window._filter = require('lodash/filter');
window._findIndex = require('lodash/findIndex');
window._find = require('lodash/find');
window._intersectionWith = require('lodash/intersectionWith');
window._orderBy = require('lodash/orderBy');
window._deburr = require('lodash/deburr');
window._replace = require('lodash/replace');
window._reject = require('lodash/reject');
window._isEmpty = require('lodash/isEmpty');
window._isEqual = require('lodash/isEqual');
window._map = require('lodash/map');
window._merge = require('lodash/merge');
window._concat = require('lodash/concat');
window._union = require('lodash/union');
window._remove = require('lodash/remove');
window._trim = require('lodash/trim');
window._mapValues= require('lodash/mapValues');
window._groupBy= require('lodash/groupBy');
window._omit= require('lodash/omit');
window._flow= require('lodash/flow');
window._property= require('lodash/property');
window._partialRight= require('lodash/partialRight');
window._some= require('lodash/some')
window._camelCase= require('lodash/camelCase')

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload)

const moment = require('moment-timezone');
const lineClamp = require('line-clamp')
const chroma = require('chroma-js');
global.chroma = chroma;

Vue.use(vueForm);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);
Vue.use(GetTextPlugin, {
  translations: translations,
  silent: true
});

Vue.use(VueMqtt);

Vue.use(require('vue-shortkey'));
Vue.directive('vue-ripple', Ripple);

/* Get browser language */
var userLang = (navigator.language || (navigator.languages && navigator.languages[0]));
userLang = LanguageService.transformLanguageName(userLang);
/* Set up config language */
//For chinese
userLang = (userLang.indexOf('zh')==0?'zh-CN':userLang);
userLang = userLang.replace(/_/g,'-');
Vue.config.language = (userLang.match( /(-)/) ?userLang:userLang+'-'+userLang.toUpperCase());

moment.locale(Vue.config.language);

//console.log(moment.tz.guess());

//vueForm.config.classes.input.invalid = 'form-control-danger';
//vueForm.config.classes.input.valid = 'form-control-success';

window.loadJS= function(file)  {
  // DOM: Create the script element
  var jsElm = document.createElement("script");
  // set the type attribute
  jsElm.type = "application/javascript";
  // make the script element load file
  jsElm.src = file;
  // finally insert the element to the body element in order to load the script
  document.body.appendChild(jsElm);
}
window.inAppCheck = function() {
return (navigator.userAgent.indexOf('ComfortLife')!=-1);
/*(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
return check;*/
};

if(inAppCheck())
{
  /*if(window.location.protocol!='file:')
  {
      //window.open('file://android_asset/www/index.html/#/home/rooms');
      //window.location = 'file://android_asset/www/index.html/'+window.location.hash;
  }*/
  var userAgentSplit = navigator.userAgent.split('-');
  var mobileSystem = userAgentSplit[1].toLowerCase();
  loadJS('./vendor/cordova/cordova_'+mobileSystem+'.js');
  loadJS('./vendor/cordova/index.js');
}

const SplashScreen = () => import('common/components/splash-screen/splash-screen.vue');

router.beforeEach((to, from, next) => {
    var auth = StorageService.getValue(localStorage, 'authorization');
    var s = (eventHub.user.rememberMe?localStorage:sessionStorage);

    eventHub.to = 
    {
        name: to.name,
        query: to.query,
        params: to.params
    }
    eventHub.from = 
    {
        name: from.name,
        query: from.query,
        params: from.params
    }

    var redirect = false;
    if(to.name=='invite' && to.query.type=='private')
    {
        const uid = to.params.uid;
        next({ name: 'privateInvite', query: to.query, params: { uid } });
    }
    if((auth==null)&&(to.name=='home' || to.name=='rooms' || (to.path=='/')))
    {
        next('/login');
    }
    else
    {
        if((to.name=='login')&&(auth!=null))
        {
            next();
        }
        else if(( to.name=='home' || to.name==undefined ))
        {
            redirect = true;
            next((StorageService.getValue(s, 'defaultView')=='tablet'?'/view':'/home/rooms'));

        }
        else
        {
            next();
        }
    }
    if(!redirect)
    {
        (to.name=='view'?CordovaService.changeOrientation('landscape'):CordovaService.changeOrientation('portrait'));
    }
});

router.afterEach((to, from) => {
    var s = (eventHub.user.rememberMe?localStorage:sessionStorage);
    StorageService.persist(s, 'routePath', to.path);
    eventHub.marketInit(to);
})

/*--------LOADING PAGE--------*/
var loadingPage = new Vue({
    el: '.loading-page',
    data: function () {
        return {
            hide : false
        }
    },
    created: function () {
        
    },
    methods: {
        setHide: function (hide) {
            this.hide = hide;
        }
    }
});
  
/*-------SPLASH SCREEN--------*/
var splashScr = new Vue({
    store,
    components: { SplashScreen },
    el: '.splash-screen',

    methods: {
        displayNotValidShare: function () {
            if(store.state.variantManager.class.shareSplashScreen)
            {
                const shareSplashScreen = store.state.variantManager.class.shareSplashScreen;
                this.$refs['splashScreen'].display(shareSplashScreen.logo,shareSplashScreen.title,this.$gettext(shareSplashScreen.subtitle));
            }
            else
            {
                this.$refs['splashScreen'].display();
            }
            
        }
    }
});

const routerObj = new Vue({});

 // Single event hub
const eventHub = new Vue({
    data:
        function () {
            return {
                    CONSTANTS:{
                        TAG : 'eventHub',
                        ONLY_MAIN_VIEW_NAMES : ['privateInvite','invite','webview','view','login','subscribe','reset-password','activate'],
                        FEATURE_NOT_AVAILABLE_SHARED_ACCOUNT : this.$gettext('This feature is not available for a shared account')
                    },
                    foreground: true,
                    commandIdList:[],
                    commandDeviceList:[],
                    user:new User(),
                    loadingPage:loadingPage,
                    splashScr:splashScr,
                    rightPanel:{
                        extend :false,
                        minimize :false,
                        url :undefined,
                        hideContent: false,
                        init: false
                    },
                    to: {},
                    from: {},
                    shareInvite :
                    {
                        shareId: '',
                        email: '',
                        authorization:''
                    },
                    startPushRegister: false,
                    ssid:''
            }
        },
    created: function () {

        this.$on('installProcess', this.installProcess);
        this.$on('goDevice', this.goDevice);
        this.$on('showToast', ToastService.show);
        UserResource.setUser(this.user);
    },

    methods: {

        addEvent: function (name,func) {
            if(this._events[name])
                delete this._events[name];
            this.$on(name, func);
        },
        addEventIfNotExist: function (name,func) {
            if(!this._events[name])
            {
                this.$on(name, func);
            }   
        },
        mainClick: function () {
            this.$emit('mainClick');
        },
        installProcess: function (color) {
            document.querySelector("body").style.backgroundColor = color;
        },
        goDevice: function () {
            router.push('/home/device');
        },
        //Check if command uid already exists
        checkCommandIdListExists: function (uid) {
            return this.commandIdList.indexOf(uid);
        },
        marketInit: function (to) {
            //if(UserResource.isRegular())return false;
            var _this = this;
            var offlinePages = this.CONSTANTS.ONLY_MAIN_VIEW_NAMES;
            if(offlinePages.indexOf(to.name)!=-1 || !store.state.variantManager.displayMarket())
            {
                this.$emit('setHideRightPanel',true);
                window.setTimeout(
                    function()
                    {
                        _this.$emit('initRightPanel', true);
                    },1
                );
            }
            else
            {
                this.$emit('setHideRightPanel',false);
                if(to.fullPath!='/home/marketplace')
                {
                    window.setTimeout(
                        function()
                        {
                            _this.$emit('initRightPanel', true);
                        },1
                    );
                }
            }
        },

        displayFeatureNotAvailableSharedAccount: function () {
            if(!store.state.bMainAccount)
            {
                this.$emit('displayAlert', this.CONSTANTS.FEATURE_NOT_AVAILABLE_SHARED_ACCOUNT, 'info');
                return false;
            }
            else{
                return true;
            }
            
        },

    }
});


// MQTT Controller
const mqttController = new Vue({
	data:
		function () {
			return {
                CONSTANTS: {
                    TAG : 'mqttController',
                },
                connect: false,
			}
		},
    created: function () {
        eventHub.$on('mqttConnect', this.mqttControllerConnect);
        eventHub.$on('mqttDisconnect', this.mqttControllerDisconnect);
        eventHub.$on('mqttSubscribe', this.mqttControllerSubscribe);
        eventHub.$on('mqttUnsubscribe', this.mqttControllerUnsubscribe);

        eventHub.$on('mqttPublish', this.mqttControllerPublish);
        eventHub.$on('mqttConnected', this.mqttConnected);
        eventHub.$on('mqttOffline', this.mqttOffline);
        eventHub.$on('mqttTopicAdd', this.mqttTopicAdd);
    },
    methods: {
        mqttControllerConnect: function() {
            //eventHub.startPushRegister = true;
            if(Vue.prototype.$mqtt!=undefined)return false;
            var mqtt = UserResource.getMqtt();
            var host = 'mqtts://'+mqtt.mqttHost+'/mqtt';
            var options = {
                port: parseInt(mqtt.mqttPort),
                host: host,
                username: mqtt.mqttUsername,
                password: mqtt.mqttPassword,
                clientId: SystemService.getClientId(),
                keepalive: 20,
                reconnectPeriod: 1000,
                checkServerIdentity: false,
                rejectUnauthorized: false,
                protocolId: 'MQIsdp',
                protocolVersion: 3,
                clean: true,
                encoding: 'utf8',
                wsOptions: {
                    rejectUnauthorized: false
                }
            };
            this.mqttConnect(host,options,eventHub);
            var mqttTopics ={};
            var _this = this;
            mqttTopics[mqtt.mqttTopics[0]] = function (data, topic)
            {
                try
                {
                    LogService.consoleLogTag(_this.CONSTANTS.TAG,'mqttTopics', 'MQTT CALLBACK', String.fromCharCode.apply(null, data));
                    var payload = JSON.parse(String.fromCharCode.apply(null, data));
                    /*var payload = {
                        "event": "infos",
                        "ip": "192.168.51.61",
                        "uptime": 18873,
                        "version": "0.18.1",
                        "timestamp": "2018-05-24 14:53:40"
                        "modules": [
                            {
                                "device": {
                                    "status": 
                                    [
                                        {"capability": "temperature", "value": "25.5"},
                                        {"capability": "desiredTemperature", "value": "20"},
                                        {"capability": "humidity", "value": "65"},
                                        {"capability": "position", "value": ">"}
                                    ],
                                },
                                "id": "9964309a3be4372bec7d6ca7ee140cfe"
                            }
                        ]
                    }*/
                    LogService.consoleLogTag(_this.CONSTANTS.TAG,'mqttTopics', 'payload.modules', payload.modules);
                    eventHub.$emit('callbackManagement', payload, 'mqtt');
                }
                catch(e){
                    console.log(e);
                };  
            }
            this.mqttTopicsCreate(mqttTopics);
            this.mqttControllerSubscribe(mqtt.mqttTopics[0]);
            
        },
        mqttControllerDisconnect: function() {
            this.mqttDisconnect();
        },

        mqttTopicAdd: function(mqttTopic) {
            var topics = Object.keys(this.mqttTopics);
            if(topics.indexOf(mqttTopic)!=-1)return false;
            var mqttTopics ={};
            var _this = this;
            mqttTopics[mqttTopic] = function (data, topic)
            {
                try
                {
                    LogService.consoleLogTag(_this.CONSTANTS.TAG,'mqttTopics', 'MQTT CALLBACK SHARE', String.fromCharCode.apply(null, data));
                    var payload = JSON.parse(String.fromCharCode.apply(null, data));
                    LogService.consoleLogTag(_this.CONSTANTS.TAG,'mqttTopics', 'payload.modules', payload.modules);
                    eventHub.$emit('callbackManagement', payload, 'mqtt');
                }
                catch(e){
                    console.log(e);
                };  
            }


            this.mqttTopicsAdd(mqttTopics);
            this.mqttControllerSubscribe(mqttTopic);
        },

        mqttTopicsUnsubscribe: function() {
            var _this = this;
            var topics = Object.keys(this.mqttTopics);
            
            var topicsWithoutPlantId = _remove(topics, function(t) {
                return t != 'addressLocation/plants/'+StorageService.getValue(localStorage, 'plantId');
            });

            topicsWithoutPlantId.forEach(function(t) {
                delete _this.mqttTopics[t];
            });

            if(topicsWithoutPlantId.length>0)
            {
                this.$mqtt.unsubscribe(topicsWithoutPlantId);
            } 
        },

        mqttControllerSubscribe: function(path) {
            var options = {
                qos: 1,
            };
            this.$mqtt.subscribe(path,options);
        },
        
        mqttControllerUnsubscribe: function(topics) {            
            this.$mqtt.unsubscribe(topics);
        },

        mqttControllerPublish: function(path, payload) {
            if(!payload.clientId)
                payload.clientId = SystemService.getClientId();
            LogService.consoleLogTag(this.CONSTANTS.TAG,'mqttControllerPublish', 'path', path);
            LogService.consoleLogTag(this.CONSTANTS.TAG,'mqttControllerPublish', 'JSON.stringify(payload)', JSON.stringify(payload));
            var options = {
                qos: 1,
            };
            this.$mqtt.publish(path, JSON.stringify(payload),options);
        },

        mqttConnected: function() {
            store.state.mqttIsConnected = true;
            //eventHub.$emit('displayAlert', this.CONSTANTS.CONNECTED_TXT, 'success');
        },

        mqttOffline: function() {
            store.state.mqttIsConnected = false;
            //eventHub.$emit('displayAlert', this.CONSTANTS.DISCONNECTED_TXT);
        },

    }
});

Vue.mixin({
    data: function () {
        return {
            inApp: inAppCheck(),
            language: Vue.config.language,
            mobileSystem: mobileSystem,
            routerObj: routerObj,
            eventHub: eventHub,
            uuidV4: uuidV4,
            moment : moment,
            lineClamp : lineClamp,
            udpJsonMessage: {},
            IMG_DEVICE_MODEL: ['ecr','prfx','car','sthi','vde','mmv','bulb','alarm','prf','tel', 'cmr', 'tel-switch', 'cmr-switch', 'dem'],
            BULB_DEVICE_MODEL: ['ecr','bulb']
        }
    },
    computed: {
        isRegular: function () {
            return UserResource.isRegular();
        }
    },
    created: function () {
    },
    methods: {

        upperFirst: function (str) {
            return (_upperFirst(str));
        },

        isImgDeviceModel: function (model) {
            return (this.IMG_DEVICE_MODEL.indexOf(model)!=-1);
        },
        isBulbModel: function (model) {
            return (this.BULB_DEVICE_MODEL.indexOf(model)!=-1);
        },
        deviceTypeClassValueNew: function (module) {
            var clsObj = {
                            'icon' : true,
                            'cl-icon' : true,
                            'cl-icon--x-large' : true
                        };
            if(this.isBulbModel(module.device.model))
            {
                clsObj['cl-icon-'+module.device.model+'-'+(module.statusvalue?'on':'off')] = true;
            }
            else
            {
                clsObj['cl-icon-'+module.device.model] = true;
            }
            if(module.statusvalue == 'off' || module.statusvalue == 'down' || (!module.statusvalue && module.device.model == 'plug'))
                clsObj['isOff'] = true;
            return clsObj;
        },
        deviceTypeClassValue: function (model) {
            var clsObj = {
                            'cl' : true,
                            'pull-left' : true
                        };
            clsObj['cl-'+model] = true;
            return clsObj;
        }
    }
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')